import { ComboBox } from "@progress/kendo-react-dropdowns";
import { useSelectedComponent } from "../../../../Hooks/Display/useComponents";
import { useComponentProperties, useFetchedValues } from "../../../../Hooks/Display/useComponentProperties";
import { useEffect, useState } from 'react';
import { byAttributeName } from "../../utils";

const DurationProperty = () => {

    const selectedComponent = useSelectedComponent();

    const [properties, setProperty] = useComponentProperties();

    const [{ generalProperties: fetchedValues }] = useFetchedValues();

    const [durationAttributes, setDurationAttributes] = useState([]);

    useEffect(() => {
        if (fetchedValues.attributes && fetchedValues.attributes.length > 0) {
            const durationAttributes = fetchedValues.attributes
                .filter(attribute => !attribute.isSystemAttribute && attribute.attributeType === "Number")
                .sort(byAttributeName);
            setDurationAttributes(durationAttributes)
        }
    }, [fetchedValues.attributes])

    const handleDurationPropertyChange = (e) => {
        setProperty("durationAttribute", e.target.value ? e.target.value : { _id: "" });
    }

    return (
        <div className="clearBtn">
            <ComboBox
                className="w-100 select-overflow "
                disabled={selectedComponent.hidden}
                onChange={handleDurationPropertyChange}
                value={properties.durationAttribute}
                textField='attributeName'
                data={durationAttributes}
                dataItemKey='_id'
            />
        </div>
    )
}

export default DurationProperty;